import { ITurno } from "../models/turno";

interface ITurnoMainProps {
    turno: ITurno;
}

const TurnoMain = (props: ITurnoMainProps): JSX.Element => {

    return props.turno != null
        ? <div className='block'>
            <div className="calling-content">
                <div>
                    <div>{props.turno.moduleNumber}</div>
                </div>
                <div>
                    <div>{props.turno.turnoNumber}</div>
                </div>
            </div>
        </div>
        : <></>

}

export default TurnoMain;